import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/add-file.svg'


const _hoisted_1 = { class: "file-upload" }
const _hoisted_2 = { class: "image-upload add-file" }
const _hoisted_3 = { class: "upload-data" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  for: "file"
}
const _hoisted_8 = { class: "button-area" }

import { onMounted, ref } from "vue";
import CommonButton from "./CommonButton.vue";
import draggable from "vuedraggable";
import { ProjectStore } from "../store/ProjectStore";
import { CommonStore } from "../store/CommonStore";
import router from "../router";


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadFile',
  setup(__props) {

const images = ref<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  { url: string; display: string; file: any; duration: string }[]
>([]);
const error = ref<string[]>([]);
const projectStore = ProjectStore();
const commonStore = CommonStore();
const showAlert = ref(false);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const requestParam = ref<any[]>([]);
const params = new FormData();

onMounted(() => {
  // ブラウザバックした時に追加したファイルがデフォルトで入るようにする
  // 下書き再提出の場合は画像は再アップロードしてもらう
  if (projectStore.fileUploadList.get(projectStore.selectedId)?.length) {
    // if (projectStore.fileUploadList.get(projectStore.selectedId)?.find((v) => v.url.includes("https://omi-liff"))) {
    //   images.value = []
    // } else {
    // images.value = projectStore.fileUploadList.get(projectStore.selectedId) || []
    // }
    images.value =
      projectStore.fileUploadList.get(projectStore.selectedId) || [];
  }
});

// 動画時間を取得する
function getDuararion(duration: number): string {
  if (!duration) return "";
  const min = Math.trunc(Math.round(duration) / 60);
  const second = Math.round(duration - min * 60);
  return min + ":" + String(second).padStart(2, "0");
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function upload(event: any) {
  await checkFiles(event);

  if (error.value.length) {
    commonStore.setToast({
      showToast: true,
      message: error.value.join("\n"),
      state: 1,
      timeout: 5000,
    });
    showAlert.value = true;
  }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function checkFiles(event: any) {
  error.value.splice(0, error.value.length);
  const fileLimit = 1024 * 1024 * 30;
  const files = Array.from(event.target.files);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  files.forEach(async (v: any,index:number) => {
    if (v.size > fileLimit) {
      error.value.push(
        `${v.name}: \r\n ファイルサイズが30MBを超えているため\r\nアップロードできません\r\nファイルの圧縮をお願いいたします`
      );
    } else if (index > 19 || images.value.length == 20) {
      if (
        error.value.find(
          (v) =>
            v ==
            `\r\n ファイルアップロード数は20件までのため\r\nアップロードできません`
        )
      )
        return;
      error.value.push(
        `\r\n ファイルアップロード数は20件までのため\r\nアップロードできません`
      );
    } else {
      const file = v;
      // new RegExp("^image/(png|jpeg)"
      if (file.type.match(/image/)) {
        const url = URL.createObjectURL(file);
        images.value.push({
          url: url,
          display: url,
          file: file,
          duration: "",
        });
      } else if (file.type.match(/video/)) {
        // サムネイルを生成する
        const url = URL.createObjectURL(file);
        // let display = ''
        file.onload = () => {};
        await createThumbnail(url).then((v) => {
          images.value.push({
            url: url,
            // eslint-disable-next-line @typescript-eslint/no-require-imports
            display: v.thumbnail,
            file: file,
            duration: getDuararion(v.duration),
          });
          params.append("file", file, file.name);
          requestParam.value.push(params);
        });
      }
    }
  });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function createThumbnail(url): Promise<any> {
  return new Promise(function (promise) {
    const video = document.createElement("video");

    const thumbnailFrame = 0; // サムネイル取得秒指定

    video.preload = "metadata";
    video.src = url;
    video.hidden = true;
    // Safari / IE11
    video.muted = true;
    video.playsInline = true;
    video.currentTime = thumbnailFrame;
    // video.play();
    video.play().catch(() => promise({
        // eslint-disable-next-line @typescript-eslint/no-require-imports
          thumbnail: require("../assets/video.svg"),
          duration: 0,
    }))

    // timeupdateイベントで動画の再生を検知しています
    const timeupdate = function () {
      snapImage();
    };

    // 2.選択された動画を新規生成した<video>要素で再生
    video.addEventListener("timeupdate", timeupdate);

    video.addEventListener("canplay", function () {
      if (video.duration > thumbnailFrame) {
        video.currentTime = thumbnailFrame;
      } else {
        video.currentTime = video.duration / 2;
      }
    });
    const snapImage = function () {
      // 3.再生後、さらに新規生成した<canvas>要素で描画
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      // 4.描画後にtoDataURL()関数を利用して画像blobを取得、適宜<img>要素へ適応
      const image = canvas.toDataURL("image/png");
      const success = image.length > 100000;
      if (success) {
        setTimeout(() => {
          // Safari対策
          URL.revokeObjectURL(url);
        }, 2000);
        return promise({ thumbnail: image, duration: video.duration });
      } else {
        // サムネイル生成失敗した場合は仮のサムネイル配置
        return promise({
        // eslint-disable-next-line @typescript-eslint/no-require-imports
          thumbnail: require("../assets/video.svg"),
          duration: video.duration || 0,
        });
      }
    };
  });
}
function deleteFile(index: number) {
  images.value.splice(index, 1);
}
async function uploadFile() {
  projectStore.setFileUploadList(projectStore.selectedId, images.value);
  projectStore.uploadResource(images.value);
  // projectStore.setSelectedId(+route.query.projectId);
  router.push("draft")
  // router.push({ name: "draft", query: { content: route.query.content || "" } });
  // router.back();
  // 下書きを送信する
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function changeRow(event: any) {
  const tmpList = images.value.filter((v) => v != event.moved.element);
  images.value.splice(0, images.value.length);
  images.value.push(...tmpList);
  images.value.splice(event.moved.newIndex, 0, event.moved.element);
}

// function preview(url: string) {
//   window.open(url);
// }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("p", null, "投稿予定画像・動画", -1 /* HOISTED */)),
    _cache[4] || (_cache[4] = _createElementVNode("p", { style: {"font-size":"12px","color":"#2c3e50","text-align":"center"} }, [
      _createTextVNode(" ※アップロードできるファイルは30MB以内"),
      _createElementVNode("br"),
      _createTextVNode(" png、jpeg、mov、mp4です ")
    ], -1 /* HOISTED */)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(draggable), {
        modelValue: images.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((images).value = $event)),
        group: "people",
        "item-key": "element",
        onChange: changeRow
      }, {
        item: _withCtx(({ element, index }) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: element.display,
              style: {"width":"100%","height":"100%","object-fit":"cover"},
              crossorigin: "anonymous"
            }, null, 8 /* PROPS */, _hoisted_4),
            _createElementVNode("span", null, _toDisplayString(index + 1), 1 /* TEXT */),
            (element.duration)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(element.duration), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", {
              class: "close",
              onClick: ($event: any) => (deleteFile(index))
            }, null, 8 /* PROPS */, _hoisted_6)
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"]),
      _createElementVNode("input", {
        id: "file",
        type: "file",
        multiple: "",
        accept: "image/png, image/jpeg,image/heif, video/mov, video/mp4, capture=camera",
        onChange: upload,
        ref: "file"
      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */)
    ]),
    (images.value.length < 20)
      ? (_openBlock(), _createElementBlock("label", _hoisted_7, _cache[2] || (_cache[2] = [
          _createElementVNode("img", {
            src: _imports_0,
            id: "add_file"
          }, null, -1 /* HOISTED */)
        ])))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(CommonButton, {
        data: {
          status: images.value.length ? 0 : 2,
          button: `ファイルをアップロードする`,
        },
        onClick: _cache[1] || (_cache[1] = ($event: any) => (images.value.length ? uploadFile() : ''))
      }, null, 8 /* PROPS */, ["data"])
    ])
  ]))
}
}

})